import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=c0fd9efa&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c0fd9efa')) {
      api.createRecord('c0fd9efa', component.options)
    } else {
      api.reload('c0fd9efa', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=c0fd9efa&", function () {
      api.rerender('c0fd9efa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2dWNcTZ6hItxn/JS/comp/ImgFallback.vue"
export default component.exports